import React, { Component } from 'react';
import Link from './Link';
import moment from 'moment';
import { PARAMS } from '../constants';
import axios from 'axios';
import ArticleCard from './ArticleCard';

class ArticleView extends Component {

    state = { articles: [] };

    componentDidMount() {
        this.getRelated();
    }

    getRelated = async () => {
        const response = await axios.create({
            baseURL: 'https://content.guardianapis.com',
        }).get('/' + this.props.article.sectionId, {
            params: { ...PARAMS, 'page-size': 8 }
        });
        this.setState({ articles: response.data.response.results });
    }

    render() {
        var article = this.props.article;
        return (
            <>
                <div className="article-view">
                    <div className="article-header">
                        <Link href={"/" + article.sectionId} className="article-section">{article.sectionName}</Link>
                        <button className="article-share material-symbols-rounded" title="Copy article link" onClick={() => this.props.copyLink(article.id)}>ios_share</button>
                    </div>
                    <h1 className="article-title">{article.fields.headline}</h1>
                    <div className="article-meta">
                        {moment(article.webPublicationDate).fromNow()}&nbsp;•&nbsp;
                        By {article.fields.byline}&nbsp;•&nbsp;
                        {Math.round((article.fields.wordcount / 10) * 0.0769)} mins
                    </div>
                    <div className="article-detail" dangerouslySetInnerHTML={{ __html: article.fields.body ? article.fields.body.replace(
                        /href\s*=\s*(['"])(https:\/\/www\.theguardian\.com\/[^'"]+)/g,
                        (match, quote, url) => {
                            const path = url.replace("https://www.theguardian.com/", "");
                            const slashCount = (path.match(/\//g) || []).length;
                            if (slashCount >= 3) {
                                return `href=${quote}${window.location.origin}/${path}`;
                            }
                            return match;
                        }
                      ) : "" }} />
                    <h6 className="article-end">_____</h6>
                </div>
                <div className="article-related">
                    <h4 className="article-related-title">More from <Link className="article-related-section" href={"/" + article.sectionId}>{article.sectionName}</Link></h4>
                    {this.state.articles.filter(i => {
                        return i.id !== article.id
                    }).slice(0, 8).map((e, index) => {
                        return (
                            <ArticleCard
                                article={e}
                                type='small'
                                key={index}
                                showArticle={this.props.showArticle} />
                        )
                    })}
                </div>
            </>
        )
    }
}

export default ArticleView;